import { render, staticRenderFns } from "./GridCol.vue?vue&type=template&id=689cb742&"
import script from "./GridCol.vue?vue&type=script&lang=js&"
export * from "./GridCol.vue?vue&type=script&lang=js&"
import style0 from "./GridCol.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports